<template>
  <v-btn-toggle
    v-model="daterange"
    variant="outlined"
    color="var(--theme-color-one)"
    mandatory>
    <v-btn value="day">รายวัน</v-btn>
    <v-btn value="week">รายสัปดาห์</v-btn>
    <v-btn value="month">รายเดือน</v-btn>
    <v-btn value="year">รายปี</v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  data() {
    return {
      daterange: 'day',
    }
  },
  props: {
    value: { types: String, require: true },
  },
  created() {
    this.daterange = this.value
  },
  watch:{
    daterange(newVal) {
      this.$emit('input', newVal)
    },
  },
}
</script>